// Hero slide videos: only the active slide's visible video plays (the desktop and
// mobile variants swap by CSS at 474px). Nothing plays while the hero is off screen
// or when reduced motion is on; the slide image stays as the poster.
(() => {
  if (window.heroVideo2026) return;
  window.heroVideo2026 = true;

  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const mobile = window.matchMedia('(max-width: 474px)');

  const initHero = (section) => {
    if (section.dataset.heroVideoReady) return;
    const videos = [...section.querySelectorAll('.hero-2026__video')];
    if (!videos.length) return;
    section.dataset.heroVideoReady = 'true';
    let inView = true;

    const sync = () => {
      videos.forEach((video) => {
        const slide = video.closest('[data-hero-slide]');
        const shouldPlay = inView
          && !reduceMotion.matches
          && slide?.classList.contains('is-active')
          && video.offsetParent !== null;
        if (shouldPlay) {
          video.preload = 'auto';
          video.play().catch(() => {});
        } else if (!video.paused) {
          video.pause();
        }
      });
    };

    const slideObserver = new MutationObserver(sync);
    section.querySelectorAll('[data-hero-slide]').forEach((slide) => {
      slideObserver.observe(slide, { attributes: true, attributeFilter: ['class'] });
    });

    if ('IntersectionObserver' in window) {
      new IntersectionObserver(([entry]) => {
        inView = entry.isIntersecting;
        sync();
      }).observe(section);
    }

    reduceMotion.addEventListener('change', sync);
    mobile.addEventListener('change', sync);
    sync();
  };

  const boot = (scope = document) => {
    scope.querySelectorAll('.hero-2026').forEach(initHero);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => boot());
  } else {
    boot();
  }
  document.addEventListener('shopify:section:load', (event) => boot(event.target));
})();
